import { mediaGQLFields } from '../media/index.js';
import { slateGQLFields } from '../slate/slate.fields.js';
const BASIC_DYNAMIC_BLOCK_FIELDS = {};
const DEFAULT_DYNAMIC_BLOCK_FIELDS = {
    slate: 'all',
};
const ALL_DYNAMIC_BLOCK_FIELDS = {
    slate: 'all',
    favicon: 'basic',
    image: 'basic',
};
export const dynamicBlockGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = BASIC_DYNAMIC_BLOCK_FIELDS;
    }
    if (!fields || fields === 'default') {
        fields = DEFAULT_DYNAMIC_BLOCK_FIELDS;
    }
    if (fields === 'all') {
        fields = ALL_DYNAMIC_BLOCK_FIELDS;
    }
    return `
    description
    id
    name
    key
    ${fields.slate
        ? `
      slate(context: $context, entityId: $entityId) {
        ${slateGQLFields(fields.slate)}
      }
    `
        : ``}
    ${fields.favicon
        ? `
      favicon {
        ${mediaGQLFields(fields.favicon)}
      }
    `
        : ``}
    ${fields.image
        ? `
      image {
        ${mediaGQLFields(fields.image)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=dynamicBlock.fields.js.map